//# sourceMappingURL=common.mjs.map
/// <reference types="./common.d.mts" />
import * as $user_id from "../../../../data_types/data/auth/user_id.mjs";
import * as $connector from "../../../../data_types/data/connector.mjs";
import * as $data_point from "../../../../data_types/data/data_point.mjs";
import * as $data_source from "../../../../data_types/data/data_source.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $typography from "../../../../ds/ds/components/typography.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $mime_types from "../../../../mime_types/mime_types.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $option_ from "../../../../tiamat/gleam/option_.mjs";
import * as $card from "../../../components/card.mjs";
import * as $store from "../../../data/store.mjs";
import { Ok, toList, Empty as $Empty, prepend as listPrepend, makeError } from "../../../gleam.mjs";
import * as $s from "../../../view/content_library/styles.mjs";

const FILEPATH = "src/view/content_library/ingestion_control/common.gleam";

function metadata(metadata) {
  return $l.column(
    toList([$l.gap(4)]),
    toList([]),
    toList([
      $option_.map_lazy_unwrap(
        metadata.page_title,
        $h.none,
        (title) => {
          return $l.row(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              $typography.text($typography.sm, $typography.medium, "Title:"),
              $typography.text($typography.sm, $typography.regular, title),
            ]),
          );
        },
      ),
      $option_.map_lazy_unwrap(
        metadata.summary,
        $h.none,
        (summary) => {
          return $l.row(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              $typography.text($typography.sm, $typography.medium, "Summary:"),
              $typography.text($typography.sm, $typography.regular, summary),
            ]),
          );
        },
      ),
      (() => {
        let $ = metadata.breadcrumbs;
        if ($ instanceof $Empty) {
          return $h.none();
        } else {
          let breadcrumbs = $;
          return $l.row(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              $typography.text(
                $typography.sm,
                $typography.medium,
                "Breadcrumbs:",
              ),
              $typography.text(
                $typography.sm,
                $typography.regular,
                $list.fold(
                  breadcrumbs,
                  "",
                  (acc, breadcrumb) => { return (acc + " > ") + breadcrumb; },
                ),
              ),
            ]),
          );
        }
      })(),
      (() => {
        let $ = metadata.labels;
        if ($ instanceof $Empty) {
          return $h.none();
        } else {
          let labels = $;
          return $l.row(
            toList([$l.gap(8)]),
            toList([]),
            listPrepend(
              $typography.text($typography.sm, $typography.medium, "Labels:"),
              $list.map(
                labels,
                (label) => {
                  return $label.label(toList([$label.content(label)]));
                },
              ),
            ),
          );
        }
      })(),
    ]),
  );
}

function display_qa(display) {
  if (!(display instanceof $data_point.DisplayQa)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "view/content_library/ingestion_control/common",
      158,
      "display_qa",
      "Pattern match failed, no pattern matched the value.",
      {
        value: display,
        start: 4831,
        end: 4876,
        pattern_start: 4842,
        pattern_end: 4866
      }
    )
  }
  return $l.column(
    toList([$l.gap(4)]),
    toList([]),
    toList([
      $l.row(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          $typography.text($typography.sm, $typography.medium, "Sheet:"),
          $typography.text(
            $typography.sm,
            $typography.regular,
            display.sheet_name,
          ),
        ]),
      ),
      $l.row(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          $typography.text($typography.sm, $typography.medium, "Row:"),
          $typography.text(
            $typography.sm,
            $typography.regular,
            $int.to_string(display.row_number),
          ),
        ]),
      ),
      $option_.map_lazy_unwrap(
        display.header,
        $h.none,
        (v) => {
          return $l.row(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              $typography.text($typography.sm, $typography.medium, "Header:"),
              $typography.text($typography.sm, $typography.regular, v),
            ]),
          );
        },
      ),
      $option_.map_lazy_unwrap(
        display.section,
        $h.none,
        (v) => {
          return $l.row(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              $typography.text($typography.sm, $typography.medium, "Section:"),
              $typography.text($typography.sm, $typography.regular, v),
            ]),
          );
        },
      ),
      $option_.map_lazy_unwrap(
        display.sub_section,
        $h.none,
        (v) => {
          return $l.row(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              $typography.text(
                $typography.sm,
                $typography.medium,
                "Sub-section:",
              ),
              $typography.text($typography.sm, $typography.regular, v),
            ]),
          );
        },
      ),
      $option_.map_lazy_unwrap(
        display.context_question,
        $h.none,
        (v) => {
          return $l.row(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              $typography.text(
                $typography.sm,
                $typography.medium,
                "Context question:",
              ),
              $typography.text($typography.sm, $typography.regular, v),
            ]),
          );
        },
      ),
      $l.row(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          $typography.text($typography.sm, $typography.medium, "Question:"),
          $typography.text(
            $typography.sm,
            $typography.regular,
            display.question,
          ),
        ]),
      ),
      $l.row(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          $typography.text($typography.sm, $typography.medium, "Answer:"),
          $typography.text($typography.sm, $typography.regular, display.answer),
        ]),
      ),
      $option_.map_lazy_unwrap(
        display.comments,
        $h.none,
        (v) => {
          return $l.row(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              $typography.text($typography.sm, $typography.medium, "Comments:"),
              $typography.text($typography.sm, $typography.regular, v),
            ]),
          );
        },
      ),
      $option_.map_lazy_unwrap(
        display.as_html,
        $h.none,
        (html) => {
          return $l.column(
            toList([$l.gap(4)]),
            toList([]),
            toList([
              $typography.text($typography.sm, $typography.medium, "HTML:"),
              $h.div(
                toList([
                  $a.dangerously_set_inner_html(
                    $a.inner_html(
                      (() => {
                        let _pipe = html;
                        return $string.slice(_pipe, 0, 300);
                      })(),
                    ),
                  ),
                ]),
                toList([]),
              ),
            ]),
          );
        },
      ),
    ]),
  );
}

function dp_display_field(dp) {
  let $ = dp.display;
  if ($ instanceof $data_point.DisplayText) {
    let as_html = $.as_html;
    let page_number = $.page_number;
    let _block;
    if (as_html instanceof Some) {
      let html = as_html[0];
      _block = $h.div(
        toList([
          $a.dangerously_set_inner_html(
            $a.inner_html(
              (() => {
                let _pipe = html;
                return $string.slice(_pipe, 0, 300);
              })(),
            ),
          ),
        ]),
        toList([]),
      );
    } else {
      _block = $h.none();
    }
    let body = _block;
    return $card.card_custom_width(
      1500,
      toList([]),
      toList([
        $card.title(toList([]), toList([$h.text("Content (HTML display)")])),
        $card.body(toList([]), toList([body])),
        $card.footer(
          toList([]),
          toList([$s.page_number($h.text("p." + $int.to_string(page_number)))]),
        ),
      ]),
    );
  } else {
    let display = $;
    return $card.card_custom_width(
      1500,
      toList([]),
      toList([
        $card.title(toList([]), toList([$h.text("QA Display")])),
        $card.body(toList([]), toList([display_qa(display)])),
      ]),
    );
  }
}

export function display_data_point(dp) {
  let kind_label = $label.label(
    toList([
      $label.neutral(),
      $label.content($data_point.kind_to_string(dp.kind)),
    ]),
  );
  let _block;
  let $ = dp.status;
  if ($ instanceof $data_point.Valid) {
    _block = $label.label(
      toList([
        $label.success(),
        $label.content($data_point.status_to_string(dp.status)),
      ]),
    );
  } else {
    _block = $label.label(
      toList([
        $label.error(),
        $label.content($data_point.status_to_string(dp.status)),
      ]),
    );
  }
  let status_label = _block;
  return $l.column(
    toList([$l.gap(16)]),
    toList([]),
    toList([
      $card.card_custom_width(
        1500,
        toList([]),
        toList([
          $card.title(
            toList([]),
            toList([$h.text("Source and Data point ids")]),
          ),
          $card.body(
            toList([]),
            toList([
              $l.column(
                toList([$l.gap(4)]),
                toList([]),
                toList([
                  $l.row(
                    toList([$l.gap(8), $l.align("center")]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Source id:",
                      ),
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        dp.source_id,
                      ),
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(8), $l.align("center")]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Data point id:",
                      ),
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        dp.id,
                      ),
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(8), $l.align("center")]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Kind:",
                      ),
                      kind_label,
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(8), $l.align("center")]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Status:",
                      ),
                      status_label,
                    ]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      ),
      $card.card_custom_width(
        1500,
        toList([]),
        toList([
          $card.title(toList([]), toList([$h.text("Metadata")])),
          $card.body(toList([]), toList([metadata(dp.metadata)])),
          $card.footer(
            toList([]),
            toList([
              (() => {
                let $1 = dp.display;
                if ($1 instanceof $data_point.DisplayText) {
                  let page_number = $1.page_number;
                  return $s.page_number(
                    $h.text("p." + $int.to_string(page_number)),
                  );
                } else {
                  return $h.none();
                }
              })(),
            ]),
          ),
        ]),
      ),
      dp_display_field(dp),
      $card.card_custom_width(
        1500,
        toList([]),
        toList([
          $card.title(toList([]), toList([$h.text("Raw text")])),
          $card.body(
            toList([]),
            toList([
              $typography.text(
                $typography.sm,
                $typography.regular,
                (() => {
                  let _pipe = dp.text;
                  return $string.slice(_pipe, 0, 300);
                })(),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

export function display_data_source(ds) {
  let _block;
  let $ = ds.status;
  if ($ instanceof $data_source.Verified) {
    _block = $label.label(
      toList([
        $label.success(),
        $label.content($data_source.status_to_string(ds.status)),
      ]),
    );
  } else if ($ instanceof $data_source.Outdated) {
    _block = $label.label(
      toList([
        $label.error(),
        $label.content($data_source.status_to_string(ds.status)),
      ]),
    );
  } else {
    _block = $label.label(
      toList([
        $label.neutral(),
        $label.content($data_source.status_to_string(ds.status)),
      ]),
    );
  }
  let status_label = _block;
  return $l.column(
    toList([$l.gap(16)]),
    toList([]),
    toList([
      $card.card_custom_width(
        1500,
        toList([]),
        toList([
          $card.title(toList([]), toList([$h.text("Source ids")])),
          $card.body(
            toList([]),
            toList([
              $l.column(
                toList([$l.gap(4)]),
                toList([]),
                toList([
                  $l.row(
                    toList([$l.gap(8), $l.align("center")]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Id:",
                      ),
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        ds.id,
                      ),
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(8), $l.align("center")]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Org id:",
                      ),
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        ds.org_id,
                      ),
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(8), $l.align("center")]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Status:",
                      ),
                      status_label,
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(8), $l.align("center")]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Kind:",
                      ),
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        $connector.to_string(ds.kind),
                      ),
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(8), $l.align("center")]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Version:",
                      ),
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        $int.to_string(ds.version),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      ),
      $card.card_custom_width(
        1500,
        toList([]),
        toList([
          $card.title(toList([]), toList([$h.text("Display")])),
          $card.body(
            toList([]),
            toList([
              $l.column(
                toList([$l.gap(4)]),
                toList([]),
                toList([
                  $l.row(
                    toList([$l.gap(8)]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Name:",
                      ),
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        ds.display.name,
                      ),
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(8)]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Mime type:",
                      ),
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        $mime_types.to_string(ds.display.mime_type),
                      ),
                    ]),
                  ),
                  $option_.map_lazy_unwrap(
                    ds.display.language,
                    $h.none,
                    (v) => {
                      return $l.row(
                        toList([$l.gap(8)]),
                        toList([]),
                        toList([
                          $typography.text(
                            $typography.sm,
                            $typography.medium,
                            "Language:",
                          ),
                          $typography.text(
                            $typography.sm,
                            $typography.regular,
                            v,
                          ),
                        ]),
                      );
                    },
                  ),
                  $option_.map_lazy_unwrap(
                    ds.display.origin,
                    $h.none,
                    (v) => {
                      return $l.row(
                        toList([$l.gap(8)]),
                        toList([]),
                        toList([
                          $typography.text(
                            $typography.sm,
                            $typography.medium,
                            "Origin:",
                          ),
                          $typography.text(
                            $typography.sm,
                            $typography.regular,
                            v,
                          ),
                        ]),
                      );
                    },
                  ),
                  (() => {
                    let $1 = ds.display.breadcrumbs;
                    if ($1 instanceof $Empty) {
                      return $h.none();
                    } else {
                      let breadcrumbs = $1;
                      return $l.row(
                        toList([$l.gap(8)]),
                        toList([]),
                        toList([
                          $typography.text(
                            $typography.sm,
                            $typography.medium,
                            "Breadcrumbs:",
                          ),
                          $typography.text(
                            $typography.sm,
                            $typography.regular,
                            $list.fold(
                              breadcrumbs,
                              "",
                              (acc, b) => { return (acc + " > ") + b; },
                            ),
                          ),
                        ]),
                      );
                    }
                  })(),
                ]),
              ),
            ]),
          ),
        ]),
      ),
      $card.card_custom_width(
        1500,
        toList([]),
        toList([
          $card.title(toList([]), toList([$h.text("Details")])),
          $card.body(
            toList([]),
            toList([
              $l.column(
                toList([$l.gap(4)]),
                toList([]),
                toList([
                  (() => {
                    let $1 = ds.authors;
                    if ($1 instanceof $Empty) {
                      return $h.none();
                    } else {
                      let authors = $1;
                      return $l.row(
                        toList([$l.gap(8)]),
                        toList([]),
                        toList([
                          $typography.text(
                            $typography.sm,
                            $typography.medium,
                            "Authors:",
                          ),
                          $typography.text(
                            $typography.sm,
                            $typography.regular,
                            $string.join(
                              $list.map(authors, $user_id.to_string),
                              ", ",
                            ),
                          ),
                        ]),
                      );
                    }
                  })(),
                  $option_.map_lazy_unwrap(
                    ds.owner,
                    $h.none,
                    (v) => {
                      return $l.row(
                        toList([$l.gap(8)]),
                        toList([]),
                        toList([
                          $typography.text(
                            $typography.sm,
                            $typography.medium,
                            "Owner:",
                          ),
                          $typography.text(
                            $typography.sm,
                            $typography.regular,
                            $user_id.to_string(v),
                          ),
                        ]),
                      );
                    },
                  ),
                  (() => {
                    let $1 = ds.tags;
                    if ($1 instanceof $Empty) {
                      return $h.none();
                    } else {
                      let tags = $1;
                      return $l.row(
                        toList([$l.gap(8)]),
                        toList([]),
                        listPrepend(
                          $typography.text(
                            $typography.sm,
                            $typography.medium,
                            "Tags:",
                          ),
                          $list.map(
                            tags,
                            (tag) => {
                              return $label.label(
                                toList([
                                  $label.neutral_light(),
                                  $label.content(tag),
                                ]),
                              );
                            },
                          ),
                        ),
                      );
                    }
                  })(),
                  $l.row(
                    toList([$l.gap(8)]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Document id:",
                      ),
                      $typography.text(
                        $typography.sm,
                        $typography.regular,
                        ds.document_id,
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

export function preview_source(store, source_id, limit) {
  let $ = $dict.get(store.ingestion_control_sources, source_id);
  if ($ instanceof Ok) {
    let data_points = $[0];
    return $redraw.fragment(
      (() => {
        let _pipe = limit;
        let _pipe$1 = $option.map(
          _pipe,
          (_capture) => { return $list.take(data_points, _capture); },
        );
        let _pipe$2 = $option.unwrap(_pipe$1, data_points);
        return $list.map(_pipe$2, display_data_point);
      })(),
    );
  } else {
    return $h.none();
  }
}
